/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Or_DividerInputs */



/**
* | output |
* | --- |
* | "or" |
*
* @param {Login_Or_DividerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_or_divider = /** @type {((inputs?: Login_Or_DividerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Or_DividerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ou")
	if (locale === "de") return /** @type {LocalizedString} */ ("oder")
	if (locale === "it") return /** @type {LocalizedString} */ ("O")
	if (locale === "ru") return /** @type {LocalizedString} */ ("или")
	if (locale === "es") return /** @type {LocalizedString} */ ("o")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("或者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("または")
	if (locale === "hi") return /** @type {LocalizedString} */ ("या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ou")
	return /** @type {LocalizedString} */ ("or")
});